import React from "react";

import Login from "./pages/login";
import AdminLogin from "./pages/adminLogin";
import Create from "./pages/create";
import Payment from "./pages/payment";
import Admin from "./pages/Admin";
import Confirmation from "./pages/confirmation";
import Paid from "./pages/paid";
import { Route, Switch } from "react-router-dom";
import Reset from "./pages/reset";

import { getFromStorage, removeFromStorage, setInStorage } from "./storage";

const isLunda = window.location.host.includes("lundarundan") ? true : false;

const localStorageObjectName = isLunda ? "lundarundan_JWT" : "branteverest_JWT";

const url = isLunda ? "https://lundarundan.se" : "https://branteverest.se";

require("./styles.css");

function App() {
  const [state, setState] = React.useState({
    token: null,
    isLunda: isLunda,
    url: url,
  });
  const handleToken = (obj) => {
    setState({ ...state, ...obj });
    setInStorage(localStorageObjectName, obj.token);
  };

  /*
  React.useEffect(() => {
    let obj = getFromStorage(localStorageObjectName);
    if (obj) {
      fetch(url + (isLunda ? "/api/lundarundan/checkJWT" : "/api/checkJWT"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: obj,
        }),
      })
        .then((res) => res.json())
        .then((json) => {
          if (json.success) {
            console.log("JWT check successful");
            setState({ ...state, ...json });
          }
        });
    }
  }, []);*/

  return state?.token ? (
    state?.isAdmin ? (
      <Switch>
        <Route render={(props) => <Admin {...state} {...props} />} />
      </Switch>
    ) : (
      <Switch>
        <Route
          path="/betalat"
          render={(props) => <Paid {...state} {...props} />}
        />
        <Route
          path="/konfirmation"
          render={(props) => <Confirmation {...state} {...props} />}
        />
        <Route
          path={`/reset/:resetString`}
          render={(props) => <Reset {...state} {...props} />}
        />
        <Route render={(props) => <Payment {...state} {...props} />} />
      </Switch>
    )
  ) : (
    <Switch>
      <Route
        path="/inloggning"
        render={(props) => (
          <Login handleToken={handleToken} {...state} {...props} />
        )}
      />
      <Route
        path="/admin"
        render={(props) => (
          <AdminLogin handleToken={handleToken} {...state} {...props} />
        )}
      />
      <Route
        path="/skapa"
        render={(props) => (
          <Create handleToken={handleToken} {...state} {...props} />
        )}
      />
      <Route
        path={`/reset/:resetString`}
        render={(props) => <Reset {...state} {...props} />}
      />
      <Route
        render={(props) => (
          <Login handleToken={handleToken} {...state} {...props} />
        )}
      />
    </Switch>
  );
}

export default App;
